import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-3xl p-2 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Images from the on-chain asset provider.", -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProviderView = _resolveComponent("ProviderView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.network != 'localhost')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ProviderView, { assetProvider: "nouns" }),
          _createVNode(_component_ProviderView, { assetProvider: "nounsArt" }),
          _createVNode(_component_ProviderView, { assetProvider: "dotNouns" }),
          _createVNode(_component_ProviderView, { assetProvider: "dotlilArt" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProviderView, { assetProvider: "pnouns" })
  ]))
}